import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { ActivityRegarding } from '../models/types/act_regarding';
import { ActivitySubject } from '../models/types/act_subject';
import { ActivityStatus } from '../models/types/act_status';
import { environment } from '../../../environments/environment';

@Injectable()
export class ManageListsService {
    constructor(
    	private http: HttpClient
    ){}

    updateWarehouseStatus(data){
        return this.http.post(`${environment.api}updatewarehousestatus`, data);
    }

    addItemsToMasterList(data){
        return this.http.post(`${environment.api}addItemsToMasterList`, data);
    }

    removeItemFromMasterList(data){
        return this.http.post(`${environment.api}removeItemFromMasterList`, data);
    }
    getRegarding() {
        return this.http.get<ActivityRegarding>(`${environment.api}activity_regarding`)
    }
    getSubject() {
        return this.http.get<ActivitySubject>(`${environment.api}activity_subject`)
    }
    getStatus() {
        return this.http.get<ActivityStatus>(`${environment.api}activity_status`)
    }
    getItems() {
        return this.http.get<ActivityStatus>(`${environment.api}oppty_items`)
    }
    getSubItems() {
        return this.http.get<ActivityStatus>(`${environment.api}oppty_sub_items`)
    }
    getCategory() {
        return this.http.get<ActivityStatus>(`${environment.api}oppty_poc_category`)
    }
    getProductSetting() {
        return this.http.get(`${environment.api}product_settings`)
    }
    getStoneSetting() {
        return this.http.get(`${environment.api}stone_settings`)
    }
    getSubStoneSetting() {
        return this.http.get(`${environment.api}substone_settings`)
    }
    // get oppty_poc_status_type 
    getPOCMaterialStatus() { 
        return this.http.get<ActivityStatus>(`${environment.api}oppty_poc_status_type`)
    }
    removeItemFromList(data){
        return this.http.post(`${environment.api}removeItemFromList`, data);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/manage-lists.service.ts